<template>
  <div>
    <div
      v-for="(buyer, idx) of body.buyers"
      :key="idx"
      outlined
      class="pb-3 mb-3"
    >
      <div class="mb-3 helmi-card-title">
        {{ idx + 1 }}.{{ buyer.roles?.map(role => {
            const roles = {
              ORGANIZATION: 'Yritys',
              ORGANIZATION_SIGNER: 'Yrityksen edustaja',
              SIGNER: 'Ostaja',
              ESTATE: 'Kuolinpesä',
              ESTATE_SIGNER: 'Kuolinpesän edustaja',
              LUONNOKSEN_VASTAANOTTAJA: 'Luonnoksen vastaanottaja'
            }

            return roles[role];
        }).join(', ') }}
      </div>

      <v-row>
        <template v-if="buyer.roles?.includes('ORGANIZATION')">
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="buyer.organization.name"
              label="Nimi"
              :rules="[rules.required]"
              @input="updateBody()"
            />
          </v-col>

          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="buyer.organization.businessId"
              label="VAT-tunnus"
              disabled
            />
          </v-col>
        </template>

        <template v-else>
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="buyer.person.firstName"
              :rules="[rules.required]"
              label="Etunimi"
            />
          </v-col>
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="buyer.person.lastName"
              :rules="[rules.required]"
              label="Sukunimi"
            />
          </v-col>
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="buyer.person.socialSecurityNumber"
              :rules="[rules.required]"
              label="Henkilötunnus"
            />
          </v-col>

          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="buyer.person.email"
              :rules="[rules.required, rules.email]"
              label="Sähköposti"
            />
          </v-col>
        </template>

        <template
          v-if="buyer.roles?.includes('SIGNER') ||
          buyer.roles?.includes('ORGANIZATION')"
        >
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="buyer.osuus"
              :rules="[rules.required, rules.fraction]"
              label="Osuus"
            />
          </v-col>
          <v-col
            md="6"
            cols="12"
            class="py-0"
          >
            <v-autocomplete
              v-model="buyer.bankBusinessId"
              :items="banks"
              :rules="[rules.required]"
              label="Pankki"
              item-value="businessId"
              item-text="combName"
              hint="Huom! Valinta vaihtaa kaikkien ostajien pankin"
              persistent-hint
              @change="setAllBuyersBank(buyer.bankBusinessId)"
            />
          </v-col>
        </template>
      </v-row>

      <v-radio-group
        v-if="buyer.roles?.includes('SIGNER') ||
        buyer.roles?.includes('ORGANIZATION')"
        v-model="buyer.kenenLukuunLainhuutoaHaetaan"
        label="Kenen lukuun lainhuutoa haetaan"
        hide-details
      >
        <v-radio
          v-for="(n, index) in kenenLukuunLainhuutoaHaetaanOptions"
          :key="index"
          :label="n.text"
          :value="n.value"
          :disabled="!n.supported"
        />
      </v-radio-group>
      <v-divider v-if="idx < body.buyers.length - 1 && body.buyers.length > 1" class="mt-5"/>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
    banks: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    colors: {
      base: 'primary',
      text: 'primary--text',
    },
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
      fraction: (value) => {
        const pattern = /(?:[1-9][0-9]*|0)\/[1-9][0-9]*/g;
        return pattern.test(value) || 'Virheellinen murtoluku.';
      },
    },
  }),
  computed: {
    kenenLukuunLainhuutoaHaetaanOptions() {
      if (this.config.data && this.config.data.options.kenenLukuunLainhuutoaHaetaan) {
        return this.config.data.options.kenenLukuunLainhuutoaHaetaan.values
          .map(item => ({
            text: item.displayText.fin,
            value: item.value,
            supported: item.supported,
          }));
      }
      return [];
    },
  },

  methods: {
    storePersonBank(personId, bankId) {
      localStorage.setItem(`person-bank-${personId}`, bankId);
    },

    setAllBuyersBank(bank) {
      this.body.buyers.forEach((buyer) => {
        this.storePersonBank(buyer.id, bank);

        buyer.bankBusinessId = bank; // eslint-disable-line
      });
      this.$bus.$emit('GET_DIAS_CONFIG');
    },
  },
};
</script>
